// ---- Video overlay repositioning: runs on EVERY product page ----
// Moved outside the #MrBundle guard below, since products without a
// Size/Pack option (e.g. Ritual Sets) still have a testimonial video
// overlay that needs to be attached to the first gallery image.
document.addEventListener('DOMContentLoaded', function(){
  attachVideoOverlayToFirstImage();
});

function attachVideoOverlayToFirstImage(){
  var overlay = document.querySelector('.mr-video-overlay');
  if(!overlay) return;

  var activeGallery = document.querySelector('[data-mr-size-gallery]:not([style*="display: none"])')
    || document.querySelector('[data-mr-size-gallery]')
    || document.querySelector('[id^="MediaGallery-"]');
  if(!activeGallery) return;

  var firstItem = activeGallery.querySelector('.m-product-media--item[data-index="0"]')
    || activeGallery.querySelector('.m-product-media--item');
  if(!firstItem) return;

  if(overlay.parentElement !== firstItem){
    firstItem.style.position = 'relative';
    firstItem.appendChild(overlay);

    var vidEl = overlay.querySelector('video');
    if(vidEl){
      var resumePlay = function(){
        var p = vidEl.play();
        if(p && typeof p.catch === 'function'){ p.catch(function(){ /* ignore */ }); }
      };
      resumePlay();
      setTimeout(resumePlay, 150);
    }
  }
}

// ---- Bundle / Pack selector: only runs on products that have #MrBundle ----
document.addEventListener('DOMContentLoaded', function(){
  var root = document.getElementById('MrBundle');
  if(!root) return;

  var sizePos = parseInt(root.getAttribute('data-size-position'), 10);
  var packPos = parseInt(root.getAttribute('data-pack-position'), 10);
  var variants = JSON.parse(document.getElementById('MrBundleVariants').textContent);

  var sizeBtns = Array.prototype.slice.call(document.querySelectorAll('#MrBundleSizes [data-size]'));
  var packCards = Array.prototype.slice.call(document.querySelectorAll('#MrBundleCards [data-pack]'));
  var cta = document.getElementById('MrBundleCta');

  var activeSize = sizeBtns.length ? sizeBtns[0].getAttribute('data-size') : null;
  var activePack = null;
  packCards.forEach(function(c){ if(c.classList.contains('is-selected')){ activePack = c.getAttribute('data-pack'); } });
  if(!activePack && packCards.length){ activePack = packCards[0].getAttribute('data-pack'); }

  function optKey(pos){ return 'option' + pos; }

  function findVariant(sizeVal, packVal){
    return variants.filter(function(v){
      var sizeMatches = sizePos > 0 ? v[optKey(sizePos)] === sizeVal : true;
      return sizeMatches && v[optKey(packPos)] === packVal;
    })[0] || null;
  }

  function money(cents){
    if(typeof cents !== 'number') return '';
    var v = Math.round(cents/100).toLocaleString('en-PK');
    return 'Rs. ' + v;
  }

  function broadcast(){
    var v = findVariant(activeSize, activePack);
    document.dispatchEvent(new CustomEvent('mr:bundle:change', {
      detail: { size: activeSize, pack: activePack, variant: v }
    }));
  }

  function render(){
    packCards.forEach(function(card){
      var packVal = card.getAttribute('data-pack');
      var v = findVariant(activeSize, packVal);
      var priceEl = card.querySelector('[data-price]');
      var compareEl = card.querySelector('[data-compare]');
      var saveEl = card.querySelector('[data-save]');
      if(!v){
        priceEl.textContent = 'Unavailable';
        compareEl.textContent = '';
        saveEl.textContent = '';
        card.classList.add('is-disabled');
        return;
      }
      card.classList.remove('is-disabled');
      priceEl.textContent = money(v.price);
      if(v.compare_at_price && v.compare_at_price > v.price){
        compareEl.textContent = money(v.compare_at_price);
        var pct = Math.round((1 - (v.price / v.compare_at_price)) * 100);
        saveEl.textContent = 'Save ' + pct + '%';
      } else {
        compareEl.textContent = '';
        saveEl.textContent = '';
      }
    });
    cta.disabled = !findVariant(activeSize, activePack);

    var v = findVariant(activeSize, activePack);
    if(v){
      var form = document.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('[name="id"]') : null;
      if(idInput){
        idInput.value = v.id;
      }
      updatePriceBlock(v.id);
    }

    broadcast();
  }

  var priceEl = document.querySelector('[id^="Price-"]');
  var priceSectionId = priceEl ? priceEl.id.replace('Price-', '') : null;
  var priceFetchTimer = null;

  function updatePriceBlock(variantId){
    if(!priceEl || !priceSectionId) return;
    clearTimeout(priceFetchTimer);
    priceFetchTimer = setTimeout(function(){
      var url = window.location.pathname + '?variant=' + variantId + '&section_id=' + priceSectionId;
      fetch(url)
        .then(function(res){ return res.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshPriceEl = doc.getElementById('Price-' + priceSectionId);
          if(freshPriceEl){
            priceEl.innerHTML = freshPriceEl.innerHTML;
          }
        })
        .catch(function(){ /* fail quietly, don't break the page */ });
    }, 120);
  }

  function filterGalleryBySize(sizeVal){
    var galleries = document.querySelectorAll('[data-mr-size-gallery]');
    if(!galleries.length) return;
    galleries.forEach(function(g){
      var match = g.getAttribute('data-mr-size-gallery') === sizeVal;
      g.style.display = match ? '' : 'none';
    });
    window.dispatchEvent(new Event('resize'));
    attachVideoOverlayToFirstImage();
  }

  attachVideoOverlayToFirstImage();

  sizeBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      activeSize = btn.getAttribute('data-size');
      sizeBtns.forEach(function(b){ b.classList.toggle('is-active', b === btn); });
      filterGalleryBySize(activeSize);
      render();
    });
  });

  filterGalleryBySize(activeSize);

  packCards.forEach(function(card){
    card.addEventListener('click', function(){
      activePack = card.getAttribute('data-pack');
      packCards.forEach(function(c){ c.classList.toggle('is-selected', c === card); });
      render();
    });
  });

  var qtyValueEl = document.getElementById('MrBundleQtyValue');
  var qtyDecreaseBtn = document.querySelector('[data-qty-decrease]');
  var qtyIncreaseBtn = document.querySelector('[data-qty-increase]');
  var realQtyInput = document.querySelector('input[name="quantity"]');

  function getQty(){
    if(realQtyInput && realQtyInput.value){ return parseInt(realQtyInput.value, 10) || 1; }
    return parseInt(qtyValueEl.textContent, 10) || 1;
  }

  function setQty(val){
    if(val < 1) val = 1;
    qtyValueEl.textContent = val;
    if(realQtyInput){
      realQtyInput.value = val;
      realQtyInput.dispatchEvent(new Event('change', {bubbles:true}));
      realQtyInput.dispatchEvent(new Event('input', {bubbles:true}));
    }
  }

  setQty(getQty());

  if(qtyDecreaseBtn){
    qtyDecreaseBtn.addEventListener('click', function(){ setQty(getQty() - 1); });
  }
  if(qtyIncreaseBtn){
    qtyIncreaseBtn.addEventListener('click', function(){ setQty(getQty() + 1); });
  }

  // ---- Add to Cart click ----
  cta.addEventListener('click', function(){
    var v = findVariant(activeSize, activePack);
    if(!v) return;

    cta.disabled = true;
    var originalText = cta.textContent;
    cta.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: v.id, quantity: getQty() })
    })
    .then(function(res){ return res.json(); })
    .then(function(){
      openCartDrawer();
    })
    .catch(function(){
      window.location.href = '/cart';
    })
    .finally(function(){
      cta.disabled = false;
      cta.textContent = originalText;
    });
  });

  function openCartDrawer(){
    var drawer = document.getElementById('MinimogCartDrawer')
      || document.querySelector('m-cart-drawer, cart-drawer, #CartDrawer, [id^="CartDrawer"]');

    if(!drawer){
      window.location.href = '/cart';
      return;
    }

    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function(res){ return res.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshDrawer = doc.getElementById('MinimogCartDrawer')
          || doc.querySelector('m-cart-drawer, cart-drawer, #CartDrawer, [id^="CartDrawer"]');
        if(freshDrawer){
          drawer.innerHTML = freshDrawer.innerHTML;
        }
      })
      .catch(function(){ /* still try to open what we have */ })
      .finally(function(){
        drawer.classList.add('m-cart-drawer--active');
        if(typeof drawer.open === 'function'){
          drawer.open();
        }
      });
  }

  window.MrBundle = {
    getSizes: function(){
      return sizeBtns.map(function(b){ return b.getAttribute('data-size'); });
    },
    getState: function(){
      return { size: activeSize, pack: activePack, variant: findVariant(activeSize, activePack) };
    },
    setSize: function(sizeVal){
      var btn = sizeBtns.filter(function(b){ return b.getAttribute('data-size') === sizeVal; })[0];
      if(btn) btn.click();
    }
  };

  render();
});